import styled from "@emotion/styled";
import { Stack, Col } from "react-bootstrap";
import { isSafari } from "react-device-detect";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const SchedulingText = styled(Col)<IStyledComponentProps>`
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 0px !important;
  padding-top: 10px;

  @media (max-width: ${(props) =>
      props.theme.utils.getThemeBreakpoint("tablet")}) {
    margin: 0;
  }
`;

const TimingListItem = styled(Stack)<IStyledComponentProps>`
  &.timing-list-item {
    margin: 0 16px;
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};

    .label-cell {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      min-width: ${isSafari ? 216 : 190}px;

      span {
        text-decoration: underline dotted
          ${({ theme }) => theme.colors.brand.primary};
        text-underline-offset: 6px;

        @media (max-width: ${(props) =>
            props.theme.utils.getThemeBreakpoint("tablet")}) {
          text-underline-offset: 4px;
        }
      }

      @media (min-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        &:hover {
          cursor: pointer;
        }
      }
    }

    &:last-child {
      border-bottom: 0 none;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin: 0;
      min-height: 65px;
    }
  }
`;

export default { TimingListItem, SchedulingText };
